/**
 * Définition des statuts pouvant être associés à un consommateur
 * Customer status flags d'Openbet
 */
import { isJelMobile, inAppMobile } from '@/helpers/AppHelpers';

export const playerPaymentProfileStatus = {
  GUEST: 'GUEST',
  NONWAGER: 'NONWAGER',
  LOCKED: 'LOCK',
  CHANGE_PASSWORD: 'PWORD',
  FORGOTTEN_PASSWORD: 'FPWORD',
  BETS_BLOCKED: 'STOP',
  WITHDRAWAL_BLOCKED: 'WTD',
  DEPOSIT_BLOCKED: 'DEP',
  FAILED_OPTIMAL: 'OVS_LQV2_S',
  RETRY_OPTIMAL: 'OVS_LQV2_R',
  MANUAL_OPTIMAL: 'OVS_LQV2_M',
  NOTICE_OPTIMAL: 'OVS_LQV2_Y',
  PENDING_OPTIMAL: 'OVS_LQV2_P',
  PENDING_CARDEX: 'OVS_LQV1_P',
  FAILED_CARDEX: 'OVS_LQV1_S',
  PERFECT_CARDEX_MATCH: 'PERF_CARD',
  PARTIAL_CARDEX_MATCH: 'PART_CARD',
  DUPLICATE: 'DUPLICATE',
  WAITING_CONF: 'AWAITCONF',
  SELF_EXCL_WITHDRAWAL: 'SEXC_WTD',
  PENDING_ID: 'PENDING_ID',
  UPLOAD_ID: 'UPLOAD_ID',
  PENDING_CANAFE: 'CANAFE_MAN',
  WATCHLIST: 'Watchlist',
  FAILED_VERIFIEDME: 'OVS_LQV3_S',
  PENDING_ID_VERIFIEDME: 'OVS_LQV3_P',
  SF_LOADING: 'SF_LOADING',
};

/**
 * Sous-ensemble de playerPaymentProfileStatus
 * Correspondance parfaite OBLIGATROIRE (sauf 'aucun') avec:
 * \mon-compte\magnolia\light-modules\jel-lm\dialogs\components\inherits\baseComponent.yaml
 */

export const playerPaymentProfileStatusAffichage = [
  playerPaymentProfileStatus.GUEST,
  playerPaymentProfileStatus.FAILED_OPTIMAL,
  playerPaymentProfileStatus.MANUAL_OPTIMAL,

  playerPaymentProfileStatus.PENDING_ID,
  playerPaymentProfileStatus.UPLOAD_ID,
  playerPaymentProfileStatus.WATCHLIST,
  playerPaymentProfileStatus.FAILED_VERIFIEDME,
  playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
];

/**
 * Classe utilitaire pour le profil d'un joueur
 * TODO: Éventuellement, complètment retirer cette classe
 */
export class CustomerProfileHelper {
  /**
   * Constructeur
   * @param {*} profile  profil du joueur (JSON)
   */
  constructor(aProfile) {
    this.profile = aProfile;
  }

  /**
   * Indique si ce profil a une adresse déja enregistré
   */
  aAdresse() {
    return this.profile.hasAddress;
  }

  aAuthRetrait() {
    return (
      this.profile.withdrawalInfo &&
      this.profile.withdrawalInfo.withdrawalAuthStatus &&
      this.profile.withdrawalInfo.withdrawalAuthStatus == 'YES'
    );
  }

  // Indique si l'élément statut est contenu dans la tableau des statuts du joueur
  aStatut(statut) {
    try {
      if (this.profile.status && statut) {
        return this.profile.status.indexOf(statut) != -1;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  /**
   * Indique si le profile utilisateur contient toute la liste de statuts
   * @param {string[]} statuts   profil du joueur (JSON)
   *
   * @return {boolean} Retourne true si tous les statuts sont bien présents
   */
  aStatuts(statuts) {
    try {
      if (this.profile.status && Array.isArray(statuts)) {
        return statuts.every((statut) => this.profile.status.includes(statut));
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  /**
   * Indique si ce profil a une profession
   */
  aProfession() {
    return this.profile.hasProfession;
  }

  /**
   * Indique si le profil a de l'info de dépot
   */
  aInfoDepot() {
    return this.profile.depositInfo;
  }

  /**
   * Indique si le profil a une limite de dépot
   */
  aLimiteDepot() {
    if (this.profile.depositInfo) {
      return this.profile.depositInfo.hasDepositLimit;
    }
    return false;
  }

  isDepotBloque() {
    if (this.profile.depositInfo) {
      return this.profile.depositInfo.isBlocked;
    }
    return true;
  }

  isRetraitBloque() {
    if (this.profile.withdrawalInfo) {
      return this.profile.withdrawalInfo.isBlocked;
    }
    return true;
  }

  isUtilisateurBloque() {
    return this.profile.sessionId != null;
  }

  getAdresse() {
    if (this.profile.address) {
      return this.profile.address;
    }
    return null;
  }

  setLimiteDepotBloque() {
    // TODO: Quand profil existera
    if (this.profile.depositInfo.setLimiteDepotBloque) {
      return this.profile.depositInfo.setLimiteDepotBloque;
    }
    return null;
  }

  setLimiteRetraitBloque() {
    // TODO: Quand profil existera
    if (this.profile.depositInfo.setLimiteRetraitBloque) {
      return this.profile.depositInfo.setLimiteRetraitBloque;
    }
    return null;
  }
}
